export default __webpack_public_path__ + "static/media/pringles_150x1225px.f241c21e.jpg";